import styled from "styled-components";
import { BUTTON_HEIGHT, FONT_SIZE } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import { FONT_SIZE_SEARCH_AREA, HEIGHT_SEARCH_AREA } from "../../types";

type TextScale = keyof typeof FONT_SIZE_SEARCH_AREA;

const BORDER_COLOR = "#d9dde5";
const TEXT_COLOR = "#333333";
const PRIMARY_BUTTON_COLOR = "#1e3665";

const EDIT_ADD_BUTTON_HEIGHT = {
  small: HEIGHT_SEARCH_AREA.small,
  medium: HEIGHT_SEARCH_AREA.medium,
  large: 32,
} as const;

export const Styles = styled.div<{
  text_scale?: TextScale;
  height?: number;
  isChangeSize?: boolean;
}>`
  padding: 8px 12px 24px;
  height: 100%;
  letter-spacing: 1px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .section-header {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 4px;
    border-bottom: 1px solid ${BORDER_COLOR};
    margin-bottom: 8px;

    .select-all-row {
      margin-top: 4px;
      align-items: center;
      gap: 8px;
      flex-wrap: ${({ text_scale }) =>
        text_scale === DISPLAY_SIZES.SMALL || !text_scale ? "nowrap" : "wrap"};

      ${({ text_scale }) =>
        text_scale && text_scale !== DISPLAY_SIZES.SMALL
          ? `
        .section-description {
          flex: 1 0 100%;
          justify-content: flex-start;
        }
      `
          : ""}
    }

    .section-title-row {
      display: flex;
      justify-content: space-between;
      width: 100%;
      gap: 4px;
    }
  }

  .title-select-filter {
    font-weight: 700;
    margin: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    box-sizing: border-box;
    color: ${TEXT_COLOR};
    border: 1px solid #d9dde5 !important;
    line-height: 1;
    height: ${({ text_scale = DISPLAY_SIZES.SMALL }) =>
      `${EDIT_ADD_BUTTON_HEIGHT[text_scale]}px`};
    font-size: ${({ text_scale = DISPLAY_SIZES.SMALL }) =>
      `${FONT_SIZE_SEARCH_AREA[text_scale]}px`};
  }

  .text-title {
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    color: ${TEXT_COLOR};
    margin: 0;
    ${({ text_scale = DISPLAY_SIZES.SMALL }) =>
      `
        font-size: ${FONT_SIZE_SEARCH_AREA[text_scale]}px;
      `}
  }

  .button-edit-add {
    clip-path: none !important;
    background-color: ${PRIMARY_BUTTON_COLOR} !important;
    border-radius: 2px !important;
    box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.04) !important;
    min-width: auto !important;
    width: auto !important;
    padding: 1px 6px !important;
    font-size: ${({ text_scale }) =>
      FONT_SIZE_SEARCH_AREA[text_scale || DISPLAY_SIZES.SMALL]}px !important;
    font-weight: 700 !important;
    height: ${({ text_scale = DISPLAY_SIZES.SMALL }) =>
      `${EDIT_ADD_BUTTON_HEIGHT[text_scale]}px`} !important;
    min-height: ${({ text_scale = DISPLAY_SIZES.SMALL }) =>
      `${EDIT_ADD_BUTTON_HEIGHT[text_scale]}px`} !important;
    gap: 4px !important;

    &:hover,
    &:focus {
      background-color: ${PRIMARY_BUTTON_COLOR} !important;
      opacity: 0.9;
    }

    &:disabled {
      background-color: #e7e7e7 !important;
      opacity: 1;
      border: none !important;
      color: #9ca3af !important;
    }

    span {
      padding: 0 !important;
    }

    .btn-a-link {
      color: #fff;
      font-weight: 700;
      &-disabled {
        color: #9ca3af !important;
      }
    }
  }

  .wrap-list-option {
    overflow-y: auto;

    padding: 0;
    scrollbar-width: auto;
    scrollbar-color: var(--color-thumb-scroll) #ffffff;
    direction: rtl;

    > * {
      direction: ltr;
    }

    &::-webkit-scrollbar {
      width: auto;
    }

    &::-webkit-scrollbar-track {
      background: #ffffff;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--color-thumb-scroll);
    }

    &.box-collapse {
      align-items: center;
    }
  }

  .select-filter-item {
    border: 1px solid ${BORDER_COLOR};
    padding: 8px;
  }
  .section-description {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 8px;
    white-space: nowrap;

    .text-label {
      margin: 0;
      font-size: ${({ text_scale }) =>
        FONT_SIZE_SEARCH_AREA[text_scale || DISPLAY_SIZES.SMALL]}px !important;
    }
    .box-description {
      background-color: #4e525b;
      padding: 0px 2px;
      color: #fff;
      font-size: ${({ text_scale }) =>
        FONT_SIZE_SEARCH_AREA[text_scale || DISPLAY_SIZES.SMALL] -
        3}px !important;
      ${({ isChangeSize, height }) =>
        isChangeSize &&
        `
        min-height: ${height ? height + 6 : 0}px !important;
      `}

      ${({ isChangeSize, text_scale = DISPLAY_SIZES.SMALL, height }) =>
        isChangeSize &&
        `
        font-size: ${FONT_SIZE_SEARCH_AREA[text_scale] - 3}px;
        line-height:${height ? height + 6 : 0}px !important
      `}
    }
  }
  .select-all-filter-item {
    width: 100%;
    max-width: 180px;
  }
  .select-filter-item {
    min-width: 0;
    width: 100%;
  }
  .select-all-filter-item,
  .select-filter-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0px 8px;
    margin-bottom: 4px;
    background-color: #ffffff;
    border-radius: 0;
    cursor: pointer;
    color: ${TEXT_COLOR};
    font-size: 14px;
    line-height: 22px;
    box-shadow: none;
    text-shadow: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    ${({ text_scale = DISPLAY_SIZES.SMALL }) =>
      `
        font-size: ${FONT_SIZE_SEARCH_AREA[text_scale]}px;
      `}

    &-label {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: 400;
      color: ${TEXT_COLOR};

      &-active {
        font-weight: 700;
        color: ${TEXT_COLOR};
      }
    }

    .select-filter-checkbox {
      .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
        background-color: ${PRIMARY_BUTTON_COLOR};
        border-color: ${PRIMARY_BUTTON_COLOR};
      }

      .ant-checkbox-checked:not(.ant-checkbox-disabled)::after {
        border-color: ${PRIMARY_BUTTON_COLOR};
      }
    }

    &.box-expend {
      justify-content: flex-start;
    }

    &.box-collapse {
      justify-content: center;
      min-width: 70px;
      width: 70px;
    }
  }

  .wrap-list-option.box-collapse .select-filter-item {
    min-width: 70px;
    width: 70px;
    justify-content: center;
    padding: 6px;
  }

  .select-filter-item {
    display: flex;
    align-items: center;
    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL] + 2}px`} !important;
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
  }
  .select-filter-item-label {
    font-size: ${({ text_scale }) =>
      FONT_SIZE_SEARCH_AREA[text_scale || DISPLAY_SIZES.SMALL]}px;
    line-height: ${({ text_scale }) =>
      `${
        FONT_SIZE_SEARCH_AREA[text_scale ?? DISPLAY_SIZES.SMALL]
      }px`} !important;
  }
`;
